// updateListing.js

import { baseURL } from 'utils/api'
import Dictionary from '../dictionary'
import axios from 'axios'

const { updateListing } = Dictionary

const updateListingServies = {
  view: async (paramsObj) => {
    return axios.get(baseURL + updateListing.create(),{params: paramsObj})
  },
  add: async (data) => {
    return axios.post(baseURL + updateListing.create(), data)
  },
  delete: async (id) => {
    return axios.delete(BASE_URL + updateListing.getById(id))
  },
  edit: async (id, data) => {
    return axios.put(BASE_URL + updateListing.getById(id), data)
  },
  getDetailById: async (id) => {
    return axios.get(BASE_URL + updateListing.getById(id))
  },
}
export default updateListingServies